module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p11"
  }, [_vm._v("“Care less for your harvest than for how it is shared")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("And your life will have meaning and")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Your heart will have peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_vm._v("(Kent Nerburn)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dfb4e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007.vue
// module id = 72
// module chunks = 0